import type { CommuneData } from '@/data/communes';

interface JsonLDProps {
  commune: CommuneData;
}

export function JsonLDCommune({ commune }: JsonLDProps) {
  const { nom, slug, urlPath } = commune;

  const ld = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'LocalBusiness',
        '@id': `https://volet-charleroi.be${urlPath}`,
        name: `Volet Charleroi — Réparation volets roulants ${nom}`,
        description: `Artisan spécialiste en réparation, dépannage et motorisation de volets roulants à ${nom} et dans le Hainaut. Devis gratuit, garantie 10 ans.`,
        telephone: '+3280020410',
        email: 'info@volet-charleroi.be',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '6000 Charleroi',
          addressLocality: 'Charleroi',
          postalCode: '6000',
          addressCountry: 'BE',
        },
        areaServed: [
          { '@type': 'City', name: nom },
          { '@type': 'State', name: 'Hainaut' },
          { '@type': 'Country', name: 'BE' },
        ],
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
            opens: '08:00',
            closes: '19:00',
          },
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Friday', 'Saturday'],
            opens: '08:00',
            closes: '12:00',
          },
        ],
        priceRange: '€€',
        url: `https://volet-charleroi.be${urlPath}`,
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://volet-charleroi.be/' },
          { '@type': 'ListItem', position: 2, name: `Réparation volet roulant ${nom}`, item: `https://volet-charleroi.be${urlPath}` },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: `Quel est le délai d'intervention à ${nom} ?`,
            acceptedAnswer: {
              '@type': 'Answer',
              text: `Nous intervenons généralement sous 24 à 48 heures à ${nom}. Pour les urgences (volet bloqué en position ouverte, risque de sécurité), nous faisons notre possible pour intervenir le jour même.`,
            },
          },
          {
            '@type': 'Question',
            name: `Intervenez-vous en urgence à ${nom} ?`,
            acceptedAnswer: {
              '@type': 'Answer',
              text: `Oui, nous assurons un service de dépannage urgent 7 jours sur 7, y compris le week-end, à ${nom} et dans tout le Hainaut.`,
            },
          },
          {
            '@type': 'Question',
            name: `Le diagnostic est-il payant à ${nom} ?`,
            acceptedAnswer: {
              '@type': 'Answer',
              text: `Le diagnostic est gratuit et sans engagement. Notre technicien se déplace à ${nom}, analyse la panne et vous remet un devis clair avant toute intervention.`,
            },
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
    />
  );
}